var _ellipse, _circle, _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutTeamBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 429,
    height: 550,
    viewBox: "0 0 429 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.2908,
    cy: 102.992,
    rx: 54.2908,
    ry: 55.0892,
    fill: "#006A99"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201.743,
    cy: 297.005,
    r: 113.372,
    fill: "#25307F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.0488,
    width: 83.033,
    height: 83.033,
    fill: "#25307F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: 322.551,
    width: 226.744,
    height: 226.744,
    fill: "#FF5F45"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.744,
    y: 44.7109,
    width: 226.744,
    height: 226.744,
    fill: "#00191F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232.084,
    y: 368.859,
    width: 83.033,
    height: 83.033,
    fill: "#006A99"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 386.973,
    y: 327.344,
    width: 41.5165,
    height: 41.5165,
    fill: "#006A99"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutTeamBg1);
export default __webpack_public_path__ + "static/media/about_team_bg1.cf118186880afe4be58ec1a7ef6f69b1.svg";
export { ForwardRef as ReactComponent };